export interface LoginPayload {
    username: string,
    otp: string
}

export interface LoginResponse {
    token: string
}

export interface AuthPhoneValue {
    country: string
    country_code: string
    mobile: string
}

export const EMPTY_AUTH_PHONE: AuthPhoneValue = {
    country: 'IN',
    country_code: '91',
    mobile: '',
}

export interface RegistrationPayload {
    username: string,
    name: string,
    agency: string,
    otp: string,
    country: string,
    country_code: string,
    mobile: string
}